import keys from '@debbie/common/dist/cache/keys.js';
import { caseFilterhash, } from '@debbie/common/dist/insights/index.js';
import * as homeAPI from '../api/home.js';
import q from '../query.js';
export const homeEntity = 'home';
const pausedCasesKey = (caseFilter, creditorId) => `paused-cases-${caseFilterhash(caseFilter)}-${creditorId || ''}`;
export const usePausedCases = (caseFilter, creditorId) => q.query(pausedCasesKey(caseFilter, creditorId), () => homeAPI.getPausedCases(caseFilter, creditorId), keys.read.collection(homeEntity));
//# sourceMappingURL=index.js.map